<div class="container-fluid my-5" id="projects">
    <div class="col-12 text-center">
        <h6 class="font-brand text-white text-uppercase text-center" style="clear: none; display: inline">Nuestros </h6>
        <span class="font-brand text-brand text-uppercase text-center"> Proyectos
            realizados</span>

    </div>

    <h5 class="font-brand-secondary text-white text-uppercase text-center mt-2">Nuestro portalio de trabajos realizados
        bajo
        requerimientos de nuestros clientes

    </h5>
    <div class="swiper-container" [swiper]="projectConfig" [(index)]="index" style="padding: 30px;">
        <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let project of projects">
                <div class="row">
                    <ng-container *ngIf="project.right; else left">
                        <div class="col-9 p-0">
                            <img [src]="project.imgUrl" class="img-fluid">
                        </div>
                        <div class="col-3 align-self-center p-0">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <img class="img-fluid mb-3" src="../../../../../assets/group.svg">
                                    <h6 class="text-white">SERVICIOS APLICADOS EN LA PLATAFORMA</h6>
                                    <!--<button class="btn btn-sm btn-brand px-4">IR AL ENLACE</button>-->
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #left>
                        <div class="col-3 align-self-center p-0">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <img class="img-fluid mb-3" src="../../../../../assets/group.svg">
                                    <h6 class="text-white">SERVICIOS APLICADOS EN LA PLATAFORMA</h6>
                                    <!--<button class="btn btn-sm btn-brand px-4">IR AL ENLACE</button>-->
                                </div>
                            </div>
                        </div>
                        <div class="col-9 p-0">
                            <img [src]="project.imgUrl" class="img-fluid">
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>